import React from 'react';
import FormSelect, { MOTOR_CURRENCY_OPTIONS } from '../FormSelect';

const MotorCurrencySelect = React.memo(({ value, onChange }) => (
  <FormSelect
    label="Motor Döviz Kuru"
    value={value}
    onChange={onChange}
    options={MOTOR_CURRENCY_OPTIONS}
    hint="Motor ücretinin hesaplanacağı döviz cinsini seçin"
    className="motor-currency-group"
  />
));

export default MotorCurrencySelect;
